/* istanbul ignore file */ // While this is export only, ignore
export { Presentational as PopupModal } from './components/Presentational';
